import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useStateUrlSimple(key: string, defaultValue?: string) {
  const [params, setParams] = useSearchParams();

  let value = params.get(key);
  if (value === null) {
    console.warn(
      `URL parameter "${key}" is not set. Using default value "${defaultValue ?? ''}".`
    );
    value = defaultValue ?? '';
  }
  const setValue = useCallback(
    (newValue: string) => {
      (async () => {
        console.log(`Setting URL parameter "${key}" to "${newValue}".`);
        console.log(
          'Current URL parameters before update:',
          Object.fromEntries(params.entries())
        );
        if (newValue) {
          params.set(key, newValue);
        } else {
          params.delete(key);
        }
        setParams(params, { replace: false });
      })();
    },
    [key, params, setParams]
  );
  return [value, setValue] as const;
}
